import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { activeTab: { type: String, default: "" } }

  connect() {
    if (this.activeTabValue) {
      this.select({ currentTarget: this.tabTargets.find(t => t.dataset.tab === this.activeTabValue) })
    }
  }

  // Browsers refuse to focus an invalid field in a hidden panel and block the
  // submit without saying why, so bring the field's panel forward first.
  reveal(event) {
    const panel = event.target.closest("[data-tabs-target~='panel']")
    if (!panel || !panel.classList.contains("hidden")) return

    const tab = this.tabTargets.find(t => t.dataset.tab === panel.dataset.tab)
    if (tab) this.select({ currentTarget: tab })
  }

  select(event) {
    const selectedTab = event.currentTarget
    const tabName = selectedTab.dataset.tab

    this.tabTargets.forEach(tab => {
      const isActive = tab === selectedTab
      tab.setAttribute("aria-selected", isActive)
      tab.classList.toggle("border-rose-500", isActive)
      tab.classList.toggle("text-rose-600", isActive)
      tab.classList.toggle("border-transparent", !isActive)
      tab.classList.toggle("text-slate-500", !isActive)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== tabName)
    })
  }
}
